import { async } from 'store';
import { USER_AUTHORIZE } from './actions';
import { user } from 'api';

export default [
  ...async(USER_AUTHORIZE, user.authorize)
];
